import { Component } from '../component';
import { ImageLoadWatcher } from './image-load-watcher';

export class Wallpaper extends Component {
    private wallpaperElement: HTMLOcExpanderV1Element | null = null;

    private handleWallpaperOpened(): void {
        this.trackEvent({
            product_RichContent: ['more'],
        });
    }

    private handleWallpaperClosed(): void {
        this.trackEvent({
            product_RichContent: ['less'],
        });
    }

    public variationChanged() {
        this.wallpaperElement = document.querySelector<HTMLOcExpanderV1Element>('.js_rc_wallpaper');
        if (!this.wallpaperElement) return;

        this.wallpaperElement?.addEventListener('oc-open', () => this.handleWallpaperOpened());
        this.wallpaperElement?.addEventListener('oc-close', () => this.handleWallpaperClosed());

        const imageElements = this.wallpaperElement.querySelectorAll<HTMLImageElement>('.js_rc_wallpaper__img');
        ImageLoadWatcher.waitForAllImagesToBeLoaded(imageElements).then(() => {
            if (!this.wallpaperElement) return;

            this.trackView({
                product_RichContent: this.wallpaperElement.isCutOff ? ['foldable'] : ['not_foldable'],
            });
        });
    }
}
